import './App.css';
import formsDGT from './forms_dgt.json';
import { verificaNIF} from "./utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
    Input,
    Button,
    Field
} from "@chakra-ui/react";
import * as React from 'react'
import { useNavigate } from 'react-router-dom';
import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';

function App() {
    let navigate = useNavigate();
    const [formData, setFormData] = React.useState({"Provincia cita": ""});
    const [mandatoryFormData, setmandatoryFormData] = React.useState([]);
    const [showResidencia, setShowResidencia] = React.useState(false);
    const [allMandatoryFilled, setallMandatoryFilled] = React.useState(false);
    const [startDate, setStartDate] = React.useState(new Date());
    var current_date = new Date();
    const [endDate, setEndDate] = React.useState(new Date(current_date.getFullYear() + 1, current_date.getMonth(), current_date.getDate()));
    registerLocale('es', es)

    React.useEffect(() => {
        setPaisCanje();
    }, []);

    const decodeJwtPayload = (token) => {
        const parts = token.split(".");
        if (parts.length !== 3) {
            throw new Error("Invalid JWT format");
        }

        const payloadBase64 = parts[1];
        const decodedPayload = atob(payloadBase64);
        return JSON.parse(decodedPayload);
    };

    const setPaisCanje = async () => {
        const defaultData = {"txtIdCitado": "", "txtNombre": "", "txtApellidos": "", "txtTelefonoCitado": "", "txtMailCitado": ""};
        const defaultMandatoryData = ["txtIdCitado", "txtNombre", "txtApellidos", "txtTelefonoCitado", "txtMailCitado"];

        const token = searchParams.get("token")
        const payload = decodeJwtPayload(token)

        console.log(payload)

        defaultData["FechaMIN"] = startDate.toLocaleDateString('en-GB')
        defaultData["FechaMAX"] = endDate.toLocaleDateString('en-GB')
        defaultData["token"] = token
        defaultData["tipo_bot"] = "RC_MADRID"
        defaultData["price"] = payload["price"]
        defaultData["tguser"] = payload["tguser"]
        defaultData["rdbTipoDoc"] = "NIF/NIE"
        setFormData(defaultData);
        setmandatoryFormData(defaultMandatoryData);

        if ("extra_fields" in payload) {
            setShowNumResolucion(payload["extra_fields"].includes("numresolucion"));
            setShowFechaResolucion(payload["extra_fields"].includes("fecharesolucion"));
            setShowFicheroResolucion(payload["extra_fields"].includes("ficheroresolucion"));
        }

    }

    const [resolutionFile, setResolutionFile] = React.useState(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setResolutionFile(selectedFile);
    };

    const toBase64 = (file) => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result.split(",")[1]); // Extract only Base64 part
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const [showNumResolucion, setShowNumResolucion] = React.useState(false);
    const [showFechaResolucion, setShowFechaResolucion] = React.useState(false);
    const [showFicheroResolucion, setShowFicheroResolucion] = React.useState(false);

    const handleSubmit = async () => {
        if (validateForm()) {
            // For now, just log the data. In real scenarios, you'd send this to a server.
            console.log(formData);
            if (resolutionFile != null) {
                const fileContent = await toBase64(resolutionFile);
                formData["resolution_file"] = fileContent
            }

            fetch('https://api.notifybotstg.com/api/insert_new_tg_appointment', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);
                    navigate('success');
                })
                .catch((error) => {
                    console.error('Error:', error);
                    navigate('error');
                });
        }
    };

    const validateForm = () => {
        var fulfilled = true;
        console.log(formData)

        mandatoryFormData.forEach(field => {
            console.log(field)
            if ((formData[field] === '') || (Array.isArray(formData[field]) && formData[field].length == 0)) {
                fulfilled = false;
                console.log(formData[field])
                setallMandatoryFilled(true)
            }
        });

        fulfilled = fulfilled && (formData["rdbTipoDoc"] === "Pasaporte"     || verificaNIF(formData["txtIdCitado"]));

        return fulfilled;
    };

    const handleDropdownChange = (event) => {
        //setShowResidencia(true);
        const defaultData = {};
        const defaultMandatoryData = [];
        formsDGT[event.target.value].forEach(field => {
            defaultData[field.name] = field.type === "select" ? '' : '';
            //defaultData[field.name] = field.type === "select" ? field.options[0] : '';
            if (field.mandatory) {
                defaultMandatoryData.push(field.name)
            }
        });
        defaultMandatoryData.push("País de nacionalidad")
        defaultMandatoryData.push("Provincia cita")
        defaultData["Provincia cita"] = ""
        defaultData["FechaMIN"] = startDate.toLocaleDateString('en-GB')
        defaultData["FechaMAX"] = endDate.toLocaleDateString('en-GB')
        defaultData["Pais"] = event.target.value
        setFormData(defaultData);
        setmandatoryFormData(defaultMandatoryData);
    };

    const handleInputChange = (event) => {
        console.log(event)

        setFormData({
            ...formData,
            [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value.trimStart()
        });
    };

    const searchParams = new URLSearchParams(document.location.search)

    const [tipoDoc, setTipoDoc] = React.useState('NIF/NIE');

    return (
        <div>
            <div className="form">
                <div className="grid-container">
                    <div key="rdbTipoDoc" className="input-wrapper">
                        <label>Tipo de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <RadioGroup
                            name="rdbTipoDoc"
                            value={tipoDoc}
                            onChange={(newValue) => {
                                setTipoDoc(newValue.target.value)
                                formData["rdbTipoDoc"] = newValue.target.value
                            }}
                        >
                            <FormControlLabel value="NIF/NIE" control={<Radio/>} label="NIF/NIE"/>
                            <FormControlLabel value="Pasaporte" control={<Radio/>} label="Pasaporte"/>
                        </RadioGroup>
                    </div>
                    <div key="txtIdCitado" className="input-wrapper">
                        <label>Número de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["txtIdCitado"] !== undefined && !(formData["rdbTipoDoc"] === "PASAPORTE" || verificaNIF(formData["txtIdCitado"]))}>
                            <Input
                                name="txtIdCitado"
                                type="text"
                                value={formData["txtIdCitado"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                            />
                            <Field.ErrorText>Introduce un documento valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    <div key="txtNombre" className="input-wrapper">
                        <label>Nombre<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtNombre"
                            type="text"
                            value={formData["txtNombre"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtApellidos" className="input-wrapper">
                        <label>Apellidos<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtApellidos"
                            type="text"
                            value={formData["txtApellidos"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtTelefonoCitado" className="input-wrapper">
                        <label>Teléfono<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["txtTelefonoCitado"] && (formData["txtTelefonoCitado"].length < 9 && formData["txtTelefonoCitado"].length > 0)}>
                            <Input
                                name="txtTelefonoCitado"
                                type="tel"
                                value={formData["txtTelefonoCitado"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                                minLength={9}
                                maxLength={9}
                            />
                            <Field.ErrorText>Introduce un teléfono valido</Field.ErrorText>
                        </Field.Root>

                    </div>
                    <div key="txtMailCitado" className="input-wrapper">
                        <label>Correo electrónico<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtMailCitado"
                            type="email"
                            value={formData["txtMailCitado"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div id="FechaMIN" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Buscar fecha a partir del</label>
                        <DatePicker
                            showIcon
                            selected={startDate}
                            onSelect={(date) => setStartDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "FechaMIN",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setStartDate(date.toDate());
                                }
                            }}
                            name="FechaMIN"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale="es"
                        />
                    </div>
                    <div id="FechaMAX" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Hasta el día</label>
                        <DatePicker
                            showIcon
                            selected={endDate}
                            onSelect={(date) => setEndDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "FechaMAX",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setEndDate(date.toDate());
                                }
                            }}
                            name="FechaMAX"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            minDate={startDate}
                            locale="es"
                        />
                    </div>
                    {
                        showNumResolucion &&
                        <div id="numresolucion" className="input-wrapper">
                            <label>Numero de resolución nacionalidad (la cita puede ser anulada si no es valido)</label>
                            <Input
                                name={"numresolucion"}
                                type="text"
                                value={formData["numresolucion"] || ''}
                                onChange={handleInputChange}
                                placeholder={""}
                            />
                        </div>
                    }
                    {
                        showFechaResolucion &&
                        <div id="fecharesolucion" className="input-wrapper">
                            <label>Fecha de resolución nacionalidad (la cita puede ser anulada si no es valido)</label>
                            <Input
                                name={"fecharesolucion"}
                                type="text"
                                value={formData["fecharesolucion"] || ''}
                                onChange={handleInputChange}
                                placeholder={""}
                            />
                        </div>
                    }
                    {showFicheroResolucion &&
                        <div key="ficheroResolucionNacionalidad" className="input-wrapper">
                            <label>Archivo .pdf resolución concesión nacionalidad española (obligatorio)</label>
                            <input type="file" onChange={handleFileChange} name="ficheroResolucionNacionalidad" accept={".pdf"}/>
                        </div>
                    }
                    <Button style={{width: "100%"}} class="sendButton" variant="contained" color="primary"
                            onClick={handleSubmit}
                    >Enviar solicitud</Button>

                </div>
                {allMandatoryFilled && <p>Rellena todos los campos obligatorios *</p>}
                <div></div>
            </div>
        </div>
    );
}

export default App;
